export default {
  title: 'Einstellungen',
  reservation_hours_helper: 'Diese Zeiten legen fest, wann Gäste online Reservierungen vornehmen können.',
  reservation_hours_alert:
    'Ihre Reservierungszeiten weichen von Ihren regulären Öffnungszeiten ab. Gäste können nur zu den hier aufgeführten Zeiten buchen.',
  activated: 'Reservierungen aktiv',
  deactivated: 'Reservierungen inaktiv',
  buttons: {
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
  },
  error_messages: {
    no_google_place: {
      title: 'Das Restaurant ist mit keinem Google-Standort verbunden',
      description: 'Bitte verbinde das Restaurant mit einem Google-Standort',
    },
    toggle_failed: 'Reservierungen konnten nicht aktualisiert werden. Bitte erneut versuchen.',
  },
};
